import { render, staticRenderFns } from "./DuplicatePrevYearDataModal.vue?vue&type=template&id=38bd6dd2&scoped=true&"
import script from "./DuplicatePrevYearDataModal.vue?vue&type=script&lang=ts&"
export * from "./DuplicatePrevYearDataModal.vue?vue&type=script&lang=ts&"
import style0 from "./DuplicatePrevYearDataModal.vue?vue&type=style&index=0&id=38bd6dd2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38bd6dd2",
  null
  
)

export default component.exports